if (!customElements.get('countdown-timer')) {
  customElements.define(
    'countdown-timer',
    class CountdownTimer extends HTMLElement {
      connectedCallback() {
        const targetString = this.dataset.target;
        this.targetDate = targetString ? new Date(targetString) : null;

        this.grid = this.querySelector('[data-countdown-grid]');
        this.expiredMessage = this.querySelector('[data-countdown-expired]');

        this.hoursEl = this.querySelector('[data-hours]');
        this.minutesEl = this.querySelector('[data-minutes]');
        this.secondsEl = this.querySelector('[data-seconds]');

        if (!this.targetDate || isNaN(this.targetDate.getTime())) {
          // Invalid or missing date — hide the numbers rather than show
          // a broken/NaN countdown, so a misconfigured section fails quietly.
          if (this.grid) this.grid.hidden = true;
          return;
        }

        this.tick();
        this.interval = setInterval(() => this.tick(), 1000);
      }

      disconnectedCallback() {
        if (this.interval) clearInterval(this.interval);
      }

      tick() {
        const now = new Date().getTime();
        const distance = this.targetDate.getTime() - now;

        if (distance <= 0) {
          clearInterval(this.interval);
          if (this.grid) this.grid.hidden = true;
          if (this.expiredMessage) this.expiredMessage.hidden = false;
          return;
        }

        const hours = Math.floor(distance / (1000 * 60 * 60));
        const minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if (this.hoursEl) this.hoursEl.textContent = String(hours).padStart(2, '0');
        if (this.minutesEl) this.minutesEl.textContent = String(minutes).padStart(2, '0');
        if (this.secondsEl) this.secondsEl.textContent = String(seconds).padStart(2, '0');
      }
    }
  );
}
